// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyContent_wrapper__212ME","container":"EmptyContent_container__39IIP","txtContainer":"EmptyContent_txtContainer__Fy1D4"};